import { QueryClient } from '@tanstack/react-query';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: true,
      gcTime: Infinity,
      retryDelay: 3000, //3s
      staleTime: 3000 //3s
    }
  }
});

export default queryClient;
